<template>
  <div class="pa-3 pa-md-4">
    <!-- Botón Volver -->
    <v-btn @click="$router.back()" class="back-btn mb-2">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <!-- Card 1: Filtros de Búsqueda -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="58" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-calculator-variant-outline</v-icon>
          <span class="text-h6 font-weight-medium">Costo por Kilómetro / Hora</span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mx-1 btn-circle-tooltip"
                icon
                dark
                target="_blank"
                :href="global.helpdesk_url + 'costo_kilometro'"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon size="25" color="amber lighten-2">mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>¿Necesitas ayuda?</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text class="pa-4 pa-md-5">
          <div class="section-title d-flex align-center mb-3">
            <v-icon color="secondary" small class="mr-2">mdi-filter-variant</v-icon>
            <span class="text-subtitle-2 font-weight-bold text--primary">
              Filtros de Búsqueda
            </span>
          </div>

          <v-form ref="form" enctype="multipart/form-data">
            <v-row dense>
              <v-col cols="12" sm="6" md="4" class="pa-2">
                <v-text-field
                  type="text"
                  label="Cliente"
                  v-model="Cliente.razon_social"
                  hide-details="auto"
                  readonly
                  outlined
                  dense
                  class="rounded-lg bg-light"
                  prepend-inner-icon="mdi-domain"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="2" class="pa-2">
                <v-text-field
                  type="text"
                  label="RUC"
                  v-model="Cliente.ruc"
                  hide-details="auto"
                  readonly
                  outlined
                  dense
                  class="rounded-lg bg-light"
                  prepend-inner-icon="mdi-card-account-details-outline"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="2" class="pa-2">
                <v-select
                  :items="tiposcosto"
                  v-model="item.unidadmedida"
                  label="Tipo de costo *"
                  outlined
                  dense
                  hide-details="auto"
                  class="rounded-lg"
                  prepend-inner-icon="mdi-speedometer"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="2" class="pa-2">
                <v-select
                  :items="Years"
                  v-model="item.anio"
                  @change="onAnnio"
                  label="Año *"
                  outlined
                  dense
                  hide-details="auto"
                  class="rounded-lg"
                  prepend-inner-icon="mdi-calendar-range"
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="2" class="pa-2">
                <v-autocomplete
                  :items="MarcasNeumatico"
                  v-model="item.marca"
                  label="Marca *"
                  outlined
                  dense
                  hide-details="auto"
                  class="rounded-lg"
                  prepend-inner-icon="mdi-tire"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-4 px-md-5 pb-4 pt-0 d-flex justify-end">
          <v-btn
            color="primary"
            class="px-5 font-weight-bold elevation-1 text-none rounded-lg"
            @click="filtrar()"
          >
            <v-icon left small>mdi-filter-check</v-icon>
            Filtrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- Loader -->
    <v-col cols="12" v-if="loader == true" class="px-0">
      <v-row justify="center" class="my-6">
        <vue-loaders name="ball-beat" color="#424242" scale="1"></vue-loaders>
      </v-row>
    </v-col>

    <!-- Card 2: Resumen KPI -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="50" color="grey darken-3" dark flat class="px-3">
          <div class="d-flex align-center flex-wrap">
            <v-icon left small>mdi-chart-bell-curve-cumulative</v-icon>
            <span class="text-subtitle-1 font-weight-medium">Indicador Clave (KPI)</span>
            <!-- Celda específica seleccionada -->
            <v-chip
              v-if="celdaSeleccionada !== null"
              color="deep-purple darken-1"
              dark
              small
              class="ml-3 font-weight-bold elevation-1"
              close
              @click:close="verPromedioAnual()"
            >
              <v-icon left x-small>mdi-table-large</v-icon>
              {{
                CostoPorKilometro[celdaSeleccionada.filaIndex]
                  ? CostoPorKilometro[celdaSeleccionada.filaIndex].marca +
                    " " +
                    CostoPorKilometro[celdaSeleccionada.filaIndex].modelo
                  : ""
              }}
              &nbsp;&mdash;&nbsp;
              <span v-if="celdaSeleccionada.mes === 'anual'">Prom. Anual</span>
              <span v-else>{{ meses[parseInt(celdaSeleccionada.mes) - 1] }}</span>
            </v-chip>
            <!-- Solo mes seleccionado -->
            <v-chip
              v-else-if="mesSeleccionado !== null"
              color="primary"
              dark
              small
              class="ml-3 font-weight-bold elevation-1"
              close
              @click:close="verPromedioAnual()"
            >
              <v-icon left x-small>mdi-calendar-month</v-icon>
              Mes: {{ nombreMesKpi }}
            </v-chip>
            <!-- Promedio anual -->
            <v-chip
              v-else
              small
              color="grey lighten-2"
              class="ml-3 font-weight-bold grey--text text--darken-3 text-caption"
            >
              Promedio Anual
            </v-chip>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            v-if="mesSeleccionado !== null || celdaSeleccionada !== null"
            x-small
            text
            dark
            class="text-none font-weight-bold"
            @click="verPromedioAnual()"
          >
            <v-icon left x-small>mdi-refresh</v-icon> Ver Prom. Anual
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <div class="kpi-formula-container pa-4 rounded-lg">
            <div class="d-flex align-center justify-center text-body-2 flex-nowrap overflow-x-auto">
              <!-- Título -->
              <div
                class="text-center font-weight-bold grey--text text--darken-3 text-subtitle-2 px-3 py-2 bg-white rounded-lg elevation-1 border-subtle"
                style="line-height: 1.2"
              >
                Costo por<br />{{
                  !unidadMedidaFiltrada
                    ? "kilómetro / hora"
                    : unidadMedidaFiltrada === "H"
                    ? "hora"
                    : "kilómetro"
                }}
              </div>

              <span class="mx-3 font-weight-bold text-grey-darken-2 text-h5">=</span>

              <!-- Fracción conceptual -->
              <div class="d-inline-flex flex-column align-center px-3 py-2 bg-white rounded-lg elevation-1 border-subtle">
                <span class="pb-1 border-bottom-fraction px-2 font-weight-medium text-caption text--secondary">
                  Precio de neumáticos (USD)
                </span>
                <span class="pt-1 px-2 font-weight-medium text-caption text--secondary">
                  Rendimiento de neumáticos ({{
                    !unidadMedidaFiltrada
                      ? "km / hr"
                      : unidadMedidaFiltrada === "H"
                      ? "hr"
                      : "km"
                  }})
                </span>
              </div>

              <template
                v-if="
                  datosKpi &&
                  datosKpi.costo !== undefined &&
                  datosKpi.costo !== null
                "
              >
                <span class="mx-3 font-weight-bold text-grey-darken-2 text-h5">=</span>

                <!-- Fracción de valores reales -->
                <div
                  class="d-inline-flex flex-column align-center px-3 py-2 bg-white rounded-lg elevation-1 border-subtle"
                  v-if="datosKpi.precio !== null && datosKpi.rendimiento !== null"
                >
                  <span class="pb-1 border-bottom-fraction px-2 font-weight-bold primary--text text-subtitle-2 font-mono">
                    $
                    {{
                      Number(datosKpi.precio).toLocaleString("es-PE", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}
                  </span>
                  <span class="pt-1 px-2 font-weight-bold text--primary text-subtitle-2 font-mono">
                    {{
                      Number(datosKpi.rendimiento).toLocaleString("es-PE", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                    }}
                    {{
                      !unidadMedidaFiltrada
                        ? "km/hr"
                        : unidadMedidaFiltrada === "H"
                        ? "hr"
                        : "km"
                    }}
                  </span>
                </div>

                <span
                  v-if="datosKpi.precio !== null && datosKpi.rendimiento !== null"
                  class="mx-3 font-weight-bold text-grey-darken-2 text-h5"
                >=</span>

                <!-- Resultado -->
                <div class="kpi-result-chip px-4 py-2 rounded-lg elevation-2 font-mono">
                  <span
                    class="text-caption text-uppercase font-weight-bold opacity-80 d-block"
                    style="font-size: 0.7rem !important; letter-spacing: 0.5px"
                  >
                    Costo Calculado
                  </span>
                  <span class="text-h6 font-weight-black">
                    $ {{ Number(datosKpi.costo).toFixed(4) }}
                  </span>
                  <span class="text-caption font-weight-bold ml-1 opacity-90">
                    /
                    {{
                      !unidadMedidaFiltrada
                        ? "km/hr"
                        : unidadMedidaFiltrada === "H"
                        ? "hr"
                        : "km"
                    }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- Card 3: Tabla Matriz de Indicadores -->
    <v-col cols="12" class="px-0">
      <v-card class="rounded-lg elevation-3 overflow-hidden">
        <v-toolbar height="54" color="secondary" dark flat class="px-3">
          <v-icon left>mdi-table-clock</v-icon>
          <span class="text-subtitle-1 font-weight-medium">
            Año: {{ annio || "-" }}
          </span>
          <v-chip
            small
            color="white"
            text-color="secondary"
            class="font-weight-bold ml-3 px-3 elevation-1"
          >
            Costo por
            {{
              !unidadMedidaFiltrada
                ? "Kilómetro / Hora"
                : unidadMedidaFiltrada === "H"
                ? "Hora"
                : "Kilómetro"
            }}
          </v-chip>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            dark
            height="36"
            class="px-4 font-weight-bold elevation-1 text-none rounded-lg"
            @click="exportarAexcel"
          >
            <v-icon left small>mdi-file-excel-box</v-icon>
            Exportar Excel
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-4">
          <IndicadorCosto
            ref="tablaIndicador"
            :CostoPorKilometro="CostoPorKilometro"
            :MesesCostoPorKilometro="MesesCostoPorKilometro"
            :SelectedMes="mesSeleccionado"
            :SelectedCelda="celdaSeleccionada"
            :UnidadMedida="unidadMedidaFiltrada"
            @seleccionar-mes="onSeleccionarMes"
            @seleccionar-celda="onSeleccionarCelda"
          />
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import global from "../global";
import { axios2 as axios } from "@/interceptor/useApi";
import IndicadorCosto from "../components/indicador/tabla.vue";
import moment from "moment";

export default {
  components: {
    IndicadorCosto,
  },
  data() {
    return {
      global: global,
      item: {
        year: null,
        marca: null,
        unidadmedida: null,
      },
      unidadMedidaFiltrada: "K",
      annio: "",
      mesSeleccionado: null,
      celdaSeleccionada: null, // { filaIndex, mes }
      tiposcosto: [
        {
          value: "K",
          text: "Kilómetros",
        },
        {
          value: "H",
          text: "Horas",
        },
      ],
      meses: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      loader: false,
    };
  },
  computed: {
    ...mapState("cliente", ["Cliente"]),
    ...mapState("reporteconsolidado", ["Years"]),
    ...mapState("indicadores", [
      "MarcasNeumatico",
      "CostoPorKilometro",
      "MesesCostoPorKilometro",
      "DatosTotalesAnualCosto",
      "DatosTotalesMensualCosto",
    ]),
    datosKpi() {
      // Prioridad 1: celda específica seleccionada (fila + mes)
      if (
        this.celdaSeleccionada !== null &&
        this.celdaSeleccionada !== undefined
      ) {
        const { filaIndex, mes } = this.celdaSeleccionada;
        const fila = this.CostoPorKilometro[filaIndex];
        if (fila) {
          // Celda de promedio anual de esa fila
          if (mes === "anual") {
            return {
              costo:
                fila.indicador_anual !== undefined &&
                fila.indicador_anual !== null
                  ? parseFloat(Number(fila.indicador_anual).toFixed(4))
                  : null,
              precio:
                fila.precio_anual !== undefined && fila.precio_anual !== null
                  ? parseFloat(Number(fila.precio_anual).toFixed(2))
                  : null,
              rendimiento:
                fila.rendimiento_anual !== undefined &&
                fila.rendimiento_anual !== null
                  ? parseFloat(Number(fila.rendimiento_anual).toFixed(2))
                  : null,
            };
          }
          // Celda de mes específico de esa fila
          const mesStr = String(mes).padStart(2, "0");
          const costo = fila["indicador_mes_" + mesStr];
          const precio = fila["precio_mes_" + mesStr];
          const rendimiento = fila["rendimiento_mes_" + mesStr];
          return {
            costo:
              costo !== undefined && costo !== null
                ? parseFloat(Number(costo).toFixed(4))
                : null,
            precio:
              precio !== undefined && precio !== null
                ? parseFloat(Number(precio).toFixed(2))
                : null,
            rendimiento:
              rendimiento !== undefined && rendimiento !== null
                ? parseFloat(Number(rendimiento).toFixed(2))
                : null,
          };
        }
      }
      // Prioridad 2: mes seleccionado (promedio de todas las filas de ese mes)
      if (this.mesSeleccionado !== null && this.mesSeleccionado !== undefined) {
        const numMes = parseInt(this.mesSeleccionado);
        const mesObj = this.DatosTotalesMensualCosto.find(
          (item) => item.mes === numMes,
        );
        if (mesObj) {
          return mesObj;
        }
      }
      // Prioridad 3: promedio anual
      return this.DatosTotalesAnualCosto || {};
    },
    nombreMesKpi() {
      if (this.mesSeleccionado !== null && this.mesSeleccionado !== undefined) {
        const numMes = parseInt(this.mesSeleccionado);
        if (!isNaN(numMes) && this.meses[numMes - 1]) {
          return this.meses[numMes - 1];
        }
      }
      return "Prom. Anual";
    },
  },
  methods: {
    ...mapActions("reporteconsolidado", ["cargarAnios"]),
    ...mapActions("indicadores", [
      "cargarMarcasVehiculo",
      "reporteCostoPorKilometro",
    ]),

    onSeleccionarMes: function (mes) {
      this.mesSeleccionado = mes;
      this.celdaSeleccionada = null;
    },

    onSeleccionarCelda: function (celda) {
      this.celdaSeleccionada = celda;
      // Solo actualizar mesSeleccionado cuando hay una celda real;
      // si celda es null (p.ej. click en header de mes), no borrar mesSeleccionado
      if (celda !== null && celda !== undefined) {
        this.mesSeleccionado = celda.mes;
      }
    },

    seleccionarMes: function (mes) {
      this.mesSeleccionado = mes;
      this.celdaSeleccionada = null;
    },

    verPromedioAnual: function () {
      this.mesSeleccionado = null;
      this.celdaSeleccionada = null;
      this.$nextTick(() => {
        if (this.$refs.tablaIndicador) {
          this.$refs.tablaIndicador.activarAnual();
        }
      });
    },

    onAnnio: function () {
      this.annio = this.item.anio;
    },

    filtrar: async function () {
      this.loader = true;
      this.unidadMedidaFiltrada = this.item.unidadmedida;
      this.mesSeleccionado = null;
      this.celdaSeleccionada = null;
      await this.reporteCostoPorKilometro(this.item);
      this.loader = false;
      // Activar Prom. Anual por defecto al terminar de filtrar
      this.$nextTick(() => {
        if (this.$refs.tablaIndicador) {
          this.$refs.tablaIndicador.activarAnual();
        }
      });
    },

    exportarAexcel: function () {
      axios
        .get(
          "excel/reporteindicadorcostokmhr?" +
            global._json_to_query_string({
              id_cliente: localStorage.getItem("idcliente"),
              id_usuario: localStorage.getItem("id"),
              year: this.annio,
              marca: this.item.marca,
              unidadmedida: this.item.unidadmedida,
            }),
          {
            responseType: "blob", // Importante: especificar que la respuesta es un blob
          },
        )
        .then((response) => {
          console.log("response", response);
          // Procesar y descargar el archivo después de que la promesa se resuelva
          const contentType = response.headers["content-type"];
          let fileName =
            response.headers["nombre-archivo"] || "reporte_costo_km.xlsx";

          if (
            contentType ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            const fileBlob = new Blob([response.data], { type: contentType });
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(fileBlob);
            downloadLink.download = fileName;
            document.body.appendChild(downloadLink); // Agregar al DOM
            downloadLink.click();
            document.body.removeChild(downloadLink); // Limpiar el DOM
            URL.revokeObjectURL(downloadLink.href); // Liberar memoria
          } else {
            throw new Error("La respuesta no es un archivo Excel");
          }
        })
        .catch((error) => {
          this.errorMessage = error.response?.data || error.message;
          console.error("error!", error);
        });
    },

    pintarCostoPorKilometro: function (item, valor) {
      let pintar = "border texto-cen pa-1";
      if (valor) {
        if (valor >= item.rango_c_inferior && valor <= item.rango_c_superior)
          pintar = "border texto-cen pa-1 bg-celda-amarilla";
        if (valor < item.criterio_superior)
          pintar = "border texto-cen pa-1 bg-celda-verde";
        if (valor > item.criterio_inferior)
          pintar = "border texto-cen pa-1 bg-celda-roja";
      }
      return pintar;
    },

    tdValorCosto: function (index, item2) {
      return this.CostoPorKilometro[index]["indicador_mes_" + item2];
    },
  },
  created() {
    this.cargarAnios();
    this.cargarMarcasVehiculo();
    let fecha = moment(new Date(), "YYYY-MM-DD"); //2021-05-20 //YYYY-MM-DD
    this.annio = fecha.format("YYYY");
    this.item.anio = fecha.format("YYYY");
    this.item.unidadmedida = "K";
    this.filtrar();
  },
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

.border {
  border-style: solid;
  border-width: 1px;
}

.border-bottom {
  border-bottom: solid;
  border-width: 1px;
}

.border-top {
  border-top: solid;
  border-width: 1px;
}

.border-left {
  border-left: solid;
  border-width: 1px;
}

.border-right {
  border-right: solid;
  border-width: 1px;
}

.no-border {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: none;
}

.no-border-left {
  border-left: none;
}

.no-border-right {
  border-right: none;
}

.texto-cen {
  text-align: center;
}

.texto-izq {
  text-align: left;
}

.texto-just {
  text-align: justify;
}

.inline {
  display: inline-block;
}

.texto-arriba {
  vertical-align: text-top;
  vertical-align: top;
}

.letra-6 {
  font-size: 6pt;
}

.letra-7 {
  font-size: 7pt;
}

.letra-8 {
  font-size: 8pt;
}

.letra-9 {
  font-size: 9pt;
}

.letra-10 {
  font-size: 10pt;
}

.letra-11 {
  font-size: 11pt;
}

.letra-12 {
  font-size: 12pt;
}

.letra-14 {
  font-size: 14pt;
}

.letra-15 {
  font-size: 15pt;
}

.letra-18 {
  font-size: 18pt;
}

.letra-25 {
  font-size: 25pt;
}

.letra-30 {
  font-size: 30pt;
}

.section-title {
  border-left: 3px solid #424242;
  padding-left: 8px;
  margin-bottom: 12px;
}

.bg-light {
  background-color: #f8fafc !important;
}

.kpi-formula-container {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
}

.border-subtle {
  border: 1px solid #e2e8f0;
}

.border-bottom-fraction {
  border-bottom: 2px solid #cbd5e1;
}

.kpi-result-chip {
  background: linear-gradient(135deg, #1e293b, #0f172a);
  color: #ffffff;
  min-width: 140px;
  text-align: center;
}

.font-mono {
  font-family: monospace, "Courier New", Courier !important;
  letter-spacing: 0.2px;
}

.btn-circle-tooltip {
  background: rgba(255, 255, 255, 0.16) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  border-radius: 50% !important;
  width: 36px !important;
  height: 36px !important;
  min-width: 36px !important;
  max-width: 36px !important;
  padding: 0 !important;
  margin: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  text-decoration: none !important;
  transition: all 0.2s ease-in-out !important;
}

.btn-circle-tooltip ::v-deep .v-btn__content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 100% !important;
  line-height: 1 !important;
}

.btn-circle-tooltip ::v-deep .v-icon {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.btn-circle-tooltip:hover {
  background: rgba(255, 255, 255, 0.28) !important;
  border-color: rgba(255, 255, 255, 0.45) !important;
}
</style>
